// Handles updating the cartoACSData subset of the redux store ("state")
import {
	ADD_US_STATE_TO_FILTER_WITHIN_ACTION,
	UPDATE_US_STATE_TO_FILTER_WITHIN_ACTION,
	
	CHANGE_SELECTED_GEOGRAPHY,
	HANDLE_FETCH_ERROR_ACTION,
	INITIALIZE_CARTO_ACS_DATA_FROM_URL,
	SAVE_DATA_ACTION,
	SAVE_SUMMARY_ACTION,
	
	START_FETCH_ACTION,
	END_FETCH_ACTION,
	
	START_ACS_DATA_FETCH_ACTION,
	END_ACS_DATA_FETCH_ACTION, DATA_STORAGE_TYPES,
} from '../Actions/cartoACSDataActions'
import {GEOGRAPHY_OPTIONS} from "../../constants";
import {_createSummaryFromData} from "../selectors";
import {onlyUnique} from "../../utils"

const DEFAULT_STATE = {
	arrayOfUSStatesLoadingACSData: [],
	isLoadingCartoSummary: false,
	isLoadingCartoExtents: false,
	errorMessages: {
		[DATA_STORAGE_TYPES.summary]: '',
		[DATA_STORAGE_TYPES.extents]: '',
		[DATA_STORAGE_TYPES.data]: '',
	},
	selectedGeography: GEOGRAPHY_OPTIONS.tract, // Can be programmatically overridden on each scene using sceneSpecificGeography (or the user can manually change it)
	selectedUSStatesToFilterWithin: [],
	// Cache is initially empty, gets built up as geography/state is switch. Format:
	// [cartoLayerId1]: { summary: {...}, [stateName1]: data1, [stateName2]: data2, ... }
	// [cartoLayerId2]: { summary: {...}, [stateName1]: data1, [stateName2]: data2, ... }
	// ...
}

export default (state = DEFAULT_STATE, action) => {
	const {
		stateName, cartoLayerId, data, dataStorageType, errorMessage, newSelectedGeography, stateUpdates,
		addedUSState, updatedSelectedUSStatesToFilterWithin,
		loadingKeyName,
	} = action

	switch (action.type) {
		case START_FETCH_ACTION:
			return {
				...state,
				[loadingKeyName]: true,
				errorMessage: '',
			}
		case UPDATE_US_STATE_TO_FILTER_WITHIN_ACTION:
			return {
				...state,
				selectedUSStatesToFilterWithin: updatedSelectedUSStatesToFilterWithin.sort(),
			}
		case END_FETCH_ACTION:
			return {
				...state,
				[loadingKeyName]: false,
			}

		case START_ACS_DATA_FETCH_ACTION:
			return {
				...state,
				arrayOfUSStatesLoadingACSData: [...state.arrayOfUSStatesLoadingACSData, stateName],
				errorMessage: '',
			}
		case END_ACS_DATA_FETCH_ACTION:
			return {
				...state,
				arrayOfUSStatesLoadingACSData: state.arrayOfUSStatesLoadingACSData.filter(currentStateName => currentStateName !== stateName),
			}

		case HANDLE_FETCH_ERROR_ACTION:
			return {
				...state,
				errorMessages: {
					...state.errorMessages,
					[dataStorageType]: errorMessage,
				},
			}
		case SAVE_DATA_ACTION:
			return {
				...state,
				[cartoLayerId]: {
					...(state[cartoLayerId] || {}),
					[stateName]: data,
				}
			}
		case SAVE_SUMMARY_ACTION:
			return {
				...state,
				[cartoLayerId]: {
					...(state[cartoLayerId] || {}),
					summary: _createSummaryFromData(data)
				}
			}
		case CHANGE_SELECTED_GEOGRAPHY:
			return {
				...state,
				selectedGeography: newSelectedGeography,
			}
		case INITIALIZE_CARTO_ACS_DATA_FROM_URL:
			return {
				...state,
				...stateUpdates,
			}
		case ADD_US_STATE_TO_FILTER_WITHIN_ACTION:
			return {
				...state,
				selectedUSStatesToFilterWithin: [...state.selectedUSStatesToFilterWithin, addedUSState].filter(onlyUnique)
			}
		default:
			return state
	}
}
